export const tableColumnWidths = {
  suites: {
    name: { flex: 1 },
    latestStatus: { flex: 0.5 },
    lastExecuted: { flex: 0.5 },
    executions: { flex: 0.5 },
    latestTests: { flex: 0.5 },
    metrics: { flex: 0.75 },
    actions: { flex: 0.1 },
  },
  pipelines: {
    name: { flex: 1 },
    latestStatus: { flex: 0.5 },
    latestStages: { flex: 0.75 },
    latestJobs: { flex: 0.75 },
    runs: { flex: 0.75 },
    metrics: { flex: 1 },
    actions: { flex: 0.1 },
  },
  tests: {
    name: { flex: 1 },
    suite: { flex: 0.5 },
    latestStatus: { flex: 0.5 },
    lastExecuted: { flex: 0.5 },
    executions: { flex: 0.5 },
    metrics: { flex: 0.75 },
    actions: { flex: 0.1 },
  },
  executionRuns: {
    name: { flex: 1 },
    status: { flex: 0.5 },
    suites: { flex: 0.5 },
    tests: { flex: 0.5 },
    details: { flex: 0.5 },
    actions: { flex: 0.1 },
  },
  suiteRuns: {
    name: { flex: 1 },
    run: { flex: 0.5 },
    status: { flex: 0.5 },
    tests: { flex: 0.5 },
    output: { flex: 0.5 },
    details: { flex: 0.5 },
    actions: { flex: 0.1 },
  },
  testRuns: {
    name: { flex: 1 },
    run: { flex: 0.5 },
    status: { flex: 0.5 },
    output: { flex: 0.75 },
    details: { flex: 0.5 },
    actions: { flex: 0.1 },
  },
  resultsFiles: {
    file: { flex: 1 },
    executionRuns: { flex: 0.5 },
    suites: { flex: 0.5 },
    tests: { flex: 0.5 },
    details: { flex: 0.5 },
    actions: { flex: 0.1 },
  },
  uploads: {
    id: { flex: 1 },
    status: { flex: 0.5 },
    error: { flex: 1 },
    actions: { flex: 0.1 },
  },
} as const;
